import { PdInputPassword } from "./pd-input-password/PdInputPassword.js";
//#region src/pd-input-password/pd-input-password.ts
var tag = "pd-input-password";
if (!customElements.get(tag)) customElements.define(tag, PdInputPassword);
//#endregion
export { PdInputPassword };
